import React, { Component } from "react"

class ViAdsSlot extends Component {
  componentDidMount() {
    console.log("setting up VI ads")

    // Check for marketing consent
    if (
      window.Cookiebot &&
      window.Cookiebot.consent &&
      window.Cookiebot.consent.marketing
    ) {
      this.loadViAds()
    } else {
      console.log("Marketing consent not granted, skipping VI ads")
    }
  }

  loadViAds = () => {
    const pageUrl = encodeURIComponent(window.top.location.href)
    const isMobile = window.innerWidth <= 768 // Mobile breakpoint

    if (isMobile) {
      // Load mobile in-page ad
      this.loadInPageAd(pageUrl)
    } else {
      // Load desktop slider ad
      this.loadSliderAd(pageUrl)
    }
  }

  loadSliderAd = pageUrl => {
    console.log("Loading VI slider ad for desktop")

    // Check if script already exists to prevent duplicates
    if (
      document.querySelector('script[src*="load-110985.js"][src*="page_url"]')
    ) {
      return
    }

    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = `https://emea.hhkld.com/tag/load-110985.js?page_url=${pageUrl}`
    script.async = true

    script.onload = () => {
      console.log("VI slider ad script loaded successfully")
    }

    script.onerror = () => {
      console.error("Failed to load VI slider ad script")
    }

    window.top.document.head.appendChild(script)
  }

  loadInPageAd = pageUrl => {
    console.log("Loading VI in-page ad for mobile")

    // Check if script already exists to prevent duplicates
    if (
      document.querySelector(
        'script[src*="load-110985.js"][src*="tag_id=v110985"]'
      )
    ) {
      return
    }

    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = `https://emea.hhkld.com/tag/load-110985.js?tag_id=v110985&page_url=${pageUrl}`
    script.async = true

    script.onload = () => {
      console.log("VI in-page ad script loaded successfully")
    }

    script.onerror = () => {
      console.error("Failed to load VI in-page ad script")
    }

    window.top.document.head.appendChild(script)
  }

  render() {
    const isMobile = typeof window !== "undefined" && window.innerWidth <= 768

    return (
      <div className="vi-ads-container">
        {/* Only render the div for mobile in-page ads */}
        {isMobile && (
          <div
            id="v110985"
            style={{
              minHeight: "250px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f8f9fa",
            }}
          />
        )}
        {/* Desktop slider ads don't need a container div */}
        {!isMobile && (
          <div
            style={{
              minHeight: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Slider ad will be injected by the script */}
          </div>
        )}
      </div>
    )
  }
}

// Export as both default and named export to maintain compatibility
export default ViAdsSlot
export { ViAdsSlot }
